<div bsModal #newsection1="bs-modal" id="newsection1" class="modal fade" (onShown)="onShown()"  role="dialog" aria-labelledby="newsection1" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Edit section 1 question</h2>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <label>Language:</label>
                        <select>
                            <option value="value">English</option>
                            <option value="value">Spanish</option>
                            <option value="value">French</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label>Text:</label>
                        <textarea id="textarea" class="" #text placeholder="Question body" cols="2" rows="2"></textarea>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label>Applies to:</label>
                        <select>
                            <option selected="selected" class="option">Rater</option>
                            <option class="option">Client</option>
                            <option class="option">Both</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label>Include in results for:</label>
                        <select>
                            <option selected="selected" class="option">Rater</option>
                            <option class="option">Client</option>
                            <option class="option">Both</option>
                        </select>
                    </div>
                </div>

                <!--<div class="row">
                    <div class="col-12">
                        <label>Type:</label>
                        <select>
                            <option value="value">Fixed</option>
                            <option value="value">Test</option>
                            <option value="value">Random</option>
                        </select>
                    </div>
                </div>-->
            </div>

            <div class="modal-footer text-right">
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />

                <ng-container *ngIf="actionCreate">
                    <input type="button" (click)="saveQuestion(text.value)" class="btn btn-primary waves-effect" value="Save" />
                </ng-container>

                <ng-container *ngIf="actionEdit">
                    <input type="button" (click)="editQuestion(text.value)" class="btn btn-primary waves-effect" value="Save" />
                </ng-container>
            </div>
        </div>
    </div>
</div>
